import React, { type ReactNode } from 'react';
import { Box, Stack } from '@atlaskit/primitives';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { Link } from '@atlassian/react-resource-router';
import { ConfigEmptyState } from './empty-state/index.tsx';
import messages from './messages.tsx';
import { PrincipalList } from './principal-list/index.tsx';
import { PrincipalPicker } from './principal-picker/index.tsx';
import type { Props } from './types.tsx';

const LinkDocumentation = ({ children }: { children: ReactNode }) => (
	<Link
		href="https://support.atlassian.com/jira-service-management-cloud/docs/add-or-remove-restrictions-on-request-types/"
		target="_blank"
	>
		{children}
	</Link>
);

export const RequestTypePermissionsConfig = ({
	principals,
	prependPrincipals,
	removePrincipal,
	isEmailRequestType,
}: Props) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<FireUiAnalytics
				actionSubject="tab"
				action="viewed"
				actionSubjectId="requestTypePermission"
			/>
			{isEmailRequestType ? (
				<ConfigEmptyState />
			) : (
				<Stack space="space.300">
					<Box>
						<FormattedI18nMessage
							message={formatMessage(messages.descriptionV2, {
								linkStart: '{linkStart}',
								linkEnd: '{linkEnd}',
							})}
							componentsMapping={{
								link: LinkDocumentation,
							}}
						/>
					</Box>
					<Box>
						<Stack space="space.200">
							<PrincipalPicker
								alreadySelectedPrincipals={principals}
								addPrincipals={prependPrincipals}
							/>
							<PrincipalList principals={principals} removePrincipal={removePrincipal} />
						</Stack>
					</Box>
				</Stack>
			)}
		</>
	);
};
